const DASHBOARD_LOCALES = ['de', 'en', 'es', 'fr', 'it', 'pt', 'pt_BR'];

export const normalizeDashboardLocale = locale => {
  if (!locale) return locale;

  const [language, region] = String(locale).replace(/-/g, '_').split('_');
  const canonicalLocale = region
    ? `${language.toLowerCase()}_${region.toUpperCase()}`
    : language.toLowerCase();

  if (DASHBOARD_LOCALES.includes(canonicalLocale)) {
    return canonicalLocale;
  }

  if (DASHBOARD_LOCALES.includes(language.toLowerCase())) {
    return language.toLowerCase();
  }

  return locale;
};
